
export enum MenuRolePermissionEnum {
  NoAccess = 0,
  View = 1,
  Create = 2,
  Delete = 3,
  Edit = 4
}
export interface RouterData {
  permissions: MenuRolePermissionEnum[];
  parentPage?: string;
}






